// extracted by mini-css-extract-plugin
var _1 = "SectionTestTimer_fireTime__254da";
var _2 = "SectionTestTimer_icon__1124d";
var _3 = "SectionTestTimer_root__9e316";
export { _1 as "fireTime", _2 as "icon", _3 as "root" }
